module.exports = __webpack_public_path__ + "img/borderbg.c4370052.png";